import React from 'react';
import './Protocolos.css';

const Protocolos = () => {
    const protocolos = [
        //OJO!! folder is public/assets/pdfs/protocols/2026/ solo que 'public' no se escribe en el path.
        {
            name: 'Financiamiento Compartido Trienio 2027',
            link: '/assets/pdfs/trienios/TRIENIO_ 2025-2027.pdf'
        },
        {
            name: 'Protocolo alumnas embarazadas',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_ALUMNAS_EMBARAZADAS.pdf'
        },
        {
            name: 'Protocolo amenaza de atentado o tiroteo',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_AMENAZA_ATENTADO_TIROTEO.pdf'
        },
        {
            name: 'Protocolo ante fuga del establecimiento',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_ANTE_FUGA_DEL_ESTABLECIMIENTO.pdf'
        },
        {
            name: 'Protocolo de acción frente a desaparición de un alumno al interior del colegio',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_DE_ACCION_FRENTE_A_DESAPARICION_DE_UN_%20ALUMNO_AL_INTERIOR_DEL_COLEGIO.pdf'
        },
        {
            name: 'Protocolo de actuación en caso de maltrato dentro de la comunidad educativa',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_DE_ACTUACION_EN_CASO_DE_MALTRATO_DENTRO_DE_LA_COMUNIDAD_EDUCATIVA.pdf'
        },
        {
            name: 'Protocolo de actuación frente a los casos de acoso escolar o bullying',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_DE_ACTUACION_FRENTE_A_LOS_CASOS_DE_ACOSO_ESCOLAR_O_BULLYING.pdf'
        },
        {
            name: 'Protocolo de asistencia de accidentes escolares',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_DE_ASISTENCIA_DE_ACCIDENTES_ESCOLARES.pdf'
        },
        {
            name: 'Protocolo de desregulación colegio Fenix',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_DE_DESREGULACION_COLEGIO_FENIX.pdf'
        },
        {
            name: 'Protocolo de emergencias en caso de terremoto',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_DE_EMERGENCIAS_EN_CASO_DE_TERREMOTO.pdf'
        },
        {
            name: 'Protocolo de prevención del acoso sexual, laboral y violencia en el trabajo (Ley Karin)',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO%20DE%20PREVENCION_DEL_ACOSO_SEXUAL%2C_LABORAL_Y_VIOLENCIA_EN_EL_TRABAJO_LEY_KARIN_2024.pdf'
        },
        {
            name: 'Protocolo de salidas pedagógicas y giras de estudio colegio Fenix',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_DE_SALIDAS_PEDAGOGICAS_Y_GIRAS_DE_ESTUDIO_COLEGIO_FENIX.pdf'
        },
        {
            name: 'Protocolo detección, intento y consumación de suicidio',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_DETECCION%2C_INTENTO_Y_CONSUMACION_DE_SUICIDIO.pdf'
        },
        {
            name: 'Protocolo frente al uso de celulares y otros aparatos tecnológicos',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_FRENTE_AL_USO_DE_CELULARES_Y_OTROS_APARATOS_TECNOLOGICOS.pdf'
        },
        {
            name: 'Protocolo frente a vulneración de derechos y maltrato infantil',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_FRENTE_A_VULNERACION_DE_DERECHOS_Y_MALTRATO_INFANTIL.pdf'
        },
        {
            name: 'Protocolo Ley Karin — esquema de procedimiento',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_LEY_KARIN_ESQUEMA_DE_PROCEDIMIENTO.pdf'
        },
        {
            name: 'Protocolo prevención drogas y alcohol',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_PREVENCION_DROGAS-Y-ALCOHOL_2025.pdf'
        },
        {
            name: 'Protocolo prevención y abordaje ciberbullying',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_PREVENCION_Y_ABORDAJE_CIBERBULLYING.pdf'
        },
        {
            name: 'Protocolo situaciones de abuso sexual y hechos de connotación sexual',
            link: '/assets/pdfs/protocols/2026/PROTOCOLO_SITUACIONES_DE_ABUSO_SEXUAL_Y_HECHOS_DE_CONNOTACION_SEXUAL_2022.pdf'
        },
        {
            name: 'Reglamento de uso de polerón cuartos medios',
            link: '/assets/pdfs/protocols/2026/REGLAMENTO_DE_USO_DE_POLERON_CUARTOS_MEDIOS.pdf'
        },
        {
            name: 'Reglamento interno de convivencia colegio Fenix 2026',
            link: '/assets/pdfs/protocols/2026/REGLAMENTO_INTERNO_DE_CONVIVENCIA_COLEGIO_FENIX_2026.PDF'
        }
    ];
    

    return (
        <div className="protocolos-container">
            <h2 className="protocolos-title">Reglamentos y Protocolos</h2>
            <p>Procedimientos claros y específicos para abordar situaciones críticas o emergencias que pueden surgir en el entorno escolar. Estos protocolos garantizan que los estudiantes, profesores y personal administrativo estén preparados para responder de manera efectiva en caso de una emergencia, minimizando el riesgo de lesiones o daños.</p>
            <table className="protocolos-table">
                <thead>
                    <tr>
                        <th>Nombre del Protocolo</th>
                    </tr>
                </thead>
                <tbody>
                    {protocolos.map((protocolo, index) => (
                        <tr key={index}>
                            <td>
                                <a href={protocolo.link} target="_blank" rel="noreferrer noopener">
                                    {protocolo.name}
                                </a>
                            </td>
                           
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Protocolos;
